export default __webpack_public_path__ + "static/media/portfolio.3bdae780.svg";